import { RichText, _decorator } from 'cc';
import LocalizedAsset from './LocalizedAsset';
import { fillTextArgument } from '../../Utils/Utility';

const { ccclass, property, menu } = _decorator;

@ccclass('LocalizedRichText')
@menu('Internationalization/LocalizedRichText')
export default class LocalizedRichText extends LocalizedAsset<RichText> {
    @property
    private readonly textTemplate: string = '';

    public reset() {
        this.target.string = '';
    }

    protected onKeyChange(): void {
        const [messageKey, ...messageArgs] = this.key.split('|');
        const content = fillTextArgument(this.i18n.getMessage(messageKey) ?? messageKey, messageArgs);
        if (this.textTemplate) {
            this.target.string = fillTextArgument(this.textTemplate, [content]);
        } else {
            this.target.string = content;
        }
    }

    protected getTarget(): RichText {
        return this.getComponent(RichText);
    }
}
